import React from "react";
import { Form, Select } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import Icons from "components/icons";
import { useTranslation } from "components/use-hooks";
import { STAFF_WORKER_STATUS_TRANSLATIONS } from "../../helpers/staff-workers-api-helper";


const StaffWorkersStatusSelect = ({
    form,
    name = "attendance_status",
    selected = false,
    onChange = () => {},
}) => {
    const translations = useTranslation();
    const placeholder = translations[ "STAFF_MANAGEMENT.Filter_AllStatuses" ] || "All statuses";
    const options = Object.entries(STAFF_WORKER_STATUS_TRANSLATIONS).map(([ value, translation ]) => ({
        value,
        label: translations[ translation ],
    }));

    return (
        <Form.Item name={ name } noStyle>
            <Select
                allowClear
                aria-label={ placeholder }
                clearIcon={ <CloseOutlined /> }
                showArrow
                className={ `staff-workers-filter__status${
                    selected ? " staff-workers-filter__status--chosen staff-filter-control--selected" : ""
                }` }
                dropdownClassName="staff-workers-filter__dropdown"
                options={ options }
                placeholder={ placeholder }
                suffixIcon={ selected ? null : <Icons.Arrow /> }
                onChange={ (value) => {
                    form.setFieldsValue({ [ name ]: value });
                    onChange(value);
                } } />
        </Form.Item>
    );
};

export default StaffWorkersStatusSelect;
